<template>
  <div>
    <v-container fluid :style="{ 'min-height': '800px' }">
      <v-container class="contain-width">
        <v-row>
          <v-col
              cols="12"
              md="8"
              offset-md="2"
          >
            <h1 class="mt-6 mb-6">{{ $t('headings.Opt out of reminder emails') }}</h1>
            <v-card
                class="mx-auto form-card"
                outlined
            >

              <v-card-text class="text--primary">

                <p v-if="spin && invalid === false">{{ $t("Opting out email address") }} <v-icon>mdi mdi-36px mdi-spin mdi-loading</v-icon></p>

                <p v-else-if="optedOut" class="headline">{{ $t("Your email address {email} has successfully been opted out of reminder emails", {email: email}) }} <v-icon color="green">mdi mdi-36px mdi-check</v-icon></p>

                <p v-else-if="invalid">{{ $t("Your email address cannot be found") }}.</p>

              </v-card-text>

            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <Footer />
  </div>
</template>

<script>
import Footer from "./Footer.vue";
import axios from "axios";
import { store } from '../store';
import {i18n} from "../i18n";
import {mapState} from "vuex";

export default {
  name: "OptOut",
  components: {
    'Footer': Footer
  },
  data () {
    return {
      spin: false,
      optedOut: false,
      invalid: false,
      email: ''
    }
  },
  mounted () {

    let email = decodeURI(this.$route.query.email);
    this.spin = true

    let apiClient = axios.create({
      baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
      withCredentials: true,
    });

    store.dispatch('alert/clear', { root: true });

    apiClient.get('/sanctum/csrf-cookie').then(() => {
      apiClient
          .patch(process.env.VUE_APP_API_HOST + '/api/users/opt-out?email=' + email)
          .then(response => {
            console.log(response.status)
            if (response.status === 200) {
              this.optedOut = true
              this.email = response.data.email
              store.dispatch('alert/success', 'Success', { root: true });
            }
            else {
              store.dispatch('alert/error', i18n.t('An unknown error has occurred'), { root: true });
            }

            this.spin = false
          })
          .catch(error => {
            console.log(error)
            this.invalid = true
            this.spin = false
            store.dispatch('alert/error', i18n.t('Failed to find email address'), { root: true });
          })
    })
  },
  computed: {
    ...mapState({
      brand: state => state.brand
    }),
    getBackground() {
      if (this.brand === 'neotag') {
        return require('@/assets/neotag-background.jpg')
      }
      else {
        return require('@/assets/hp-banner-1.jpg')
      }
    },
  },
}
</script>

<style scoped>

</style>
